import React, { useEffect, useState } from "react";
import Sidebar from './Components/Sidebar/Sidebar'
import MaterialTable from "material-table";
import 'material-icons/iconfont/material-icons.css';
import { collection, getDocs, addDoc, doc, updateDoc, deleteDoc } from "firebase/firestore";
import db from '../firebase-config'
import Cookies from 'universal-cookie'

const cookies = new Cookies();

function Clientes() {
  const [array, setArray] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const isIrving = cookies.get('username') === 'Irving';

  const exportarJSON = () => {
    const json = JSON.stringify(array, null, 2);
    const blob = new Blob([json], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `clientes_${new Date().toISOString().slice(0, 10)}.json`;
    a.click();
    URL.revokeObjectURL(url);
  };

  useEffect(() => {
    let cancelled = false;

    const obtenerDatos = async () => {
      setLoading(true);
      setError(null);
      try {
        const datos = await getDocs(collection(db, 'clientes'));
        if (cancelled) return;

        const items = [];
        datos.forEach((documento) => {
          items.push({
            id: documento.id,
            domicilio:    documento.data().domicilio,
            estadoCivil:  documento.data().estadoCivil,
            nacimiento:   documento.data().nacimiento,
            nombre:       documento.data().nombre,
            rfc:          documento.data().rfc,
            telefono:     documento.data().telefono,
          });
        });
        setArray(items);
      } catch (err) {
        if (!cancelled) setError('No se pudieron cargar los clientes. Intenta de nuevo.');
        console.error('Error fetching clientes:', err);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    obtenerDatos();
    return () => { cancelled = true; };
  }, []);

  const columnas = [
    { title: 'Nombre',              field: 'nombre' },
    { title: 'Fecha de nacimiento', field: 'nacimiento' },
    { title: 'Domicilio',           field: 'domicilio' },
    { title: 'RFC',                 field: 'rfc' },
    { title: 'Estado Civil',        field: 'estadoCivil' },
    { title: 'Teléfono',            field: 'telefono' },
  ];

  async function deleteCliente(row) {
    try {
      await deleteDoc(doc(db, "clientes", row.id));
    } catch (e) {
      console.error("Error al borrar cliente:", e);
    }
  }

  async function updateCliente(oldRow, newRow) {
    try {
      await updateDoc(doc(db, "clientes", oldRow.id), {
        domicilio:   newRow.domicilio,
        estadoCivil: newRow.estadoCivil,
        nacimiento:  newRow.nacimiento,
        nombre:      newRow.nombre,
        rfc:         newRow.rfc,
        telefono:    newRow.telefono,
      });
    } catch (e) {
      console.error("Error al actualizar cliente:", e);
    }
  }

  async function createCliente(cliente) {
    try {
      const docRef = await addDoc(collection(db, "clientes"), {
        domicilio:   cliente.domicilio,
        estadoCivil: cliente.estadoCivil,
        nacimiento:  cliente.nacimiento,
        nombre:      cliente.nombre,
        rfc:         cliente.rfc,
        telefono:    cliente.telefono,
      });
      return docRef.id;
    } catch (e) {
      console.error("Error al crear cliente:", e);
    }
  }

  return (
    <div className="wrapper">
      <nav>
        <Sidebar />
      </nav>
      <div className="marg">
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '1.5rem' }}>
          <h1 style={{ margin: 0 }}>Administrar clientes</h1>
          {isIrving && <button
            onClick={exportarJSON}
            disabled={loading || array.length === 0}
            style={{
              display: 'flex', alignItems: 'center', gap: '0.4rem',
              padding: '0.5rem 1rem', borderRadius: 8,
              border: '1px solid #cbd5e0', background: '#fff',
              color: '#4a5568', fontSize: '0.875rem', fontWeight: 500,
              cursor: loading || array.length === 0 ? 'not-allowed' : 'pointer',
              opacity: loading || array.length === 0 ? 0.5 : 1,
              transition: 'background 0.15s',
            }}
            onMouseEnter={e => e.currentTarget.style.background = '#f7fafc'}
            onMouseLeave={e => e.currentTarget.style.background = '#fff'}
            title="Descargar todos los datos como JSON"
          >
            ⬇ Exportar JSON
          </button>}
        </div>

        {error && (
          <div style={{
            background: '#fff5f5', border: '1px solid #feb2b2',
            borderRadius: 8, padding: '0.75rem 1rem',
            color: '#c53030', marginBottom: '1rem'
          }}>
            {error}
          </div>
        )}

        <MaterialTable
          columns={columnas}
          data={array}
          title="Clientes"
          isLoading={loading}
          editable={{
            onRowAdd: (newRow) => new Promise((resolve) => {
              createCliente(newRow).then(id => {
                setArray(prev => [...prev, { ...newRow, id }]);
                resolve();
              });
            }),
            onRowDelete: (selectedRow) => new Promise((resolve) => {
              deleteCliente(selectedRow).then(() => {
                setArray(prev => prev.filter((_, i) => i !== selectedRow.tableData.id));
                resolve();
              });
            }),
            onRowUpdate: (newRow, oldRow) => new Promise((resolve) => {
              updateCliente(oldRow, newRow).then(() => {
                setArray(prev => {
                  const updated = [...prev];
                  updated[oldRow.tableData.id] = newRow;
                  return updated;
                });
                resolve();
              });
            }),
          }}
          options={{
            actionsColumnIndex: -1,
            exportAllData: true,
            columnsButton: true,
            exportButton: true,
            pageSize: 10,
            pageSizeOptions: [10, 25, 50],
            loadingType: 'linear',
          }}
          localization={{
            header: { actions: 'Acciones' },
            body: {
              editRow: { deleteText: '¿Estás seguro de que quieres borrarlo?' },
              addTooltip: 'Agregar cliente',
              deleteTooltip: 'Borrar',
              editTooltip: 'Editar',
              emptyDataSourceMessage: loading ? 'Cargando...' : 'No hay clientes registrados',
            },
            pagination: {
              labelRowsSelect: 'filas',
              labelDisplayedRows: '{from}-{to} de {count}',
              firstTooltip: 'Primera página',
              previousTooltip: 'Página anterior',
              nextTooltip: 'Siguiente página',
              lastTooltip: 'Última página',
            },
            toolbar: {
              searchPlaceholder: 'Buscar...',
              exportTitle: 'Exportar',
              showColumnsTitle: 'Columnas',
            },
          }}
        />
      </div>
    </div>
  );
}

export default Clientes;
